/* Mobile toggle*/
$('.mobile-toggle').on('click', function(){
  $('.navigation-ul').toggleClass("active"); 
}); 

$(".navigation-ul .dropdown").click(function(){
       $(this).toggleClass('active').siblings().removeClass('active');
});

/* Homepage slider */
 $('.home-banner').slick({
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
});


 $('.seller-slider').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
     {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
     }
    },
    {
      breakpoint: 767,
       settings: {
        slidesToShow: 2,
         slidesToScroll: 1
       }
     },
    {
      breakpoint: 480,
       settings: {
        slidesToShow: 1,
         slidesToScroll: 1
       }
    }
 ]
 
});

/* Homepage wrap divs */


/* Product page tabs */
$(document).ready(function(){
	
	$('ul.description-tabs li.description-tab-link').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.description-tabs li.description-tab-link').removeClass('current');
		$('.description-tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})

})

/* Product page qty */

jQuery(document).ready(function(){
    // This button will increment the value
    $('.qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(1);
        }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 1) {
            // Decrement one
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(1);
        }
    });
});

/* Product page size chart*/

$('.modal-toggle').on('click', function(e) {
  e.preventDefault();
  $('.product-size-modal').toggleClass('is-visible');
  $('body').toggleClass('is-visible');
});

/* Product box hover class*/

 $(document).ready(function () {
    $(".box-on-hover").hover(function () {
      $(this).toggleClass("box-hover");
    });
  });

/* Collection page Grid/List mode */
$(document).ready(function() {
 
  var $theList = $(".boost-pfs-filter-right");
  var $gridBtn = $(".icon-mode-grid");
  var $listBtn = $(".icon-mode-list");
  
  $theList.addClass('grid');
  $gridBtn.addClass('active');
  
  $gridBtn.on('click', function() {
    
    $listBtn.removeClass('active');
    $(this).addClass('active');
    
    $theList.removeClass('list');
    $theList.addClass('grid');
  });
  
  $listBtn.on('click', function() {
    
    $gridBtn.removeClass('active');
    $(this).addClass('active');
    
    $theList.removeClass('grid');
    $theList.addClass('list');
  });
});

$(document).ready(function(){
    jQuery('.sort-per-page select.num').on('change', function(){
      window.location.replace(jQuery(this).val());
    });
});

/* Collection left accordion */

  $(function() {
	var Accordion = function(el, multiple) {
		this.el = el || {};
		this.multiple = multiple || false;

		// Variables privadas
		var links = this.el.find('.link');
		// Evento
		links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
	}

	Accordion.prototype.dropdown = function(e) {
		var $el = e.data.el;
			$this = $(this),
			$next = $this.next();

		$next.slideToggle();
		$this.parent().toggleClass('open');

		if (!e.data.multiple) {
			$el.find('.coll_submenu').not($next).slideUp().parent().removeClass('open');
		};
	}	

	var accordion = new Accordion($('#coll_accordion'), false);
  });

$("#product-size-chart-popup").click(function() {
    $('html, body').animate({
        scrollTop: $("html").offset().top
    }, 1000);
});

/* As seen on page slider*/

$(document).ready(function(){
  $('.as-seen-carousel').slick({
  slidesToShow: 1,
  dots:true,
  });
});


$(document).ready(function(){
  $('.as-seen-carousel-index').slick({
  slidesToShow: 4,
  dots:true,
  });
});
